const DragType = Object.freeze({
  NewItem: 1,
  MoveItem: 2,
});

const MoveItemType = Object.freeze({
  Root_To_Root: 1,
  Within_Same_Section: 2,
  Section_To_Another_Section: 3,
  Within_Same_SubSection: 4,
  SubSection_To_Another_SubSection: 5,
  Root_To_Section: 6,
  Root_To_SubSection: 7,
  Section_To_SubSection: 8,
  SubSection_To_Section: 9,
  SubSection_To_Root: 10,
  Section_To_Root: 11,
});

const PageType = Object.freeze({
  Predefined: 1,
  Report: 2,
  "Custom Page": 3,
  Disabled: 4,
});

const PredefinedPages = Object.freeze({
  "A/B Tests": "g4c_abtest",
  Accounts: "account",
  "Automation Dashboard": "automation_dashboard",
  "Automation List": "automation",
  "Journey Planner": "journey_planner",
  Audiences: "g4c_communicationaudience",
  "Blacklist and Mail Exclusions": "blacklist_and_mail_exclusion",
  "Communication Activities": "g4c_communicationactivity",
  Competitions: "dwcompetition",
  "Competition Stages": "dwcompetitionstage",
  Contacts: "contact",
  "Data Import": "data_import",
  "Data Models": "dwdatamodel",
  "Email Communications": "g4c_communication",
  "Event Profiles": "dweventprofile",
  "Email Reporting Groups": "g4c_subscriptiongroup",
  Fixtures: "dwfixture",
  "Fixture Grades": "dwfixturegrade",
  Opponents: "dwopponent",
  "Opponent Types": "dwopponenttype",
  "Reporting Campaigns": "campaign",
  Search: "search",
  Seasons: "dwseason",
  "Seasonal Periods": "dwseasonalperiod",
  "Static Marketing Lists": "list",
  "Ticket Hospitality Products": "dwtickethospitalityproduct",
  Teams: "dwteam",
  Types: "dwtype",
  "Venue Statuses": "dwhomestatus",
});

export { DragType, MoveItemType, PageType, PredefinedPages };
